import Washroom from './WashroomContainer';

export default Washroom;
